import { signedApiClient } from './apiClient';

class InviteService {

  private inviteEndpoint: string = '';

  initService(inviteEndpoint: string) {
    this.inviteEndpoint = inviteEndpoint;
  }

  async resendUserInvite(inviteIdentifier: string) {
    const uri = `${this.inviteEndpoint}/${inviteIdentifier}`;
    const apiClient = signedApiClient('POST', uri);
    return await apiClient.post(uri);
  }

  async deleteUserInvite(inviteIdentifier: string) {
    const uri = `${this.inviteEndpoint}/${inviteIdentifier}`;
    const apiClient = signedApiClient('DELETE', uri);
    return await apiClient.delete(uri);
  }
}

export default new InviteService();
